import React from "react";

const MetricCard = ({
  title,
  subtitle,
  value,
  percentage,
  isMonetary = false,
  color = "emerald",
}) => {
  const colorClasses = {
    emerald: {
      text: "text-emerald-500",
      circle: "text-emerald-500",
      track: "text-emerald-100",
    },
    red: {
      text: "text-red-500",
      circle: "text-red-500",
      track: "text-red-100",
    },
    blue: {
      text: "text-blue-500",
      circle: "text-blue-500",
      track: "text-blue-100",
    },
    yellow: {
      text: "text-yellow-500",
      circle: "text-yellow-500",
      track: "text-yellow-100",
    },
  }[color];

  return (
    <div className="p-6 bg-white rounded-lg shadow-sm flex items-center gap-6">
      {percentage !== undefined && (
        <div className="relative w-20 h-20 flex-shrink-0">
          <svg className="w-full h-full" viewBox="0 0 36 36">
            <path
              className={`stroke-current ${colorClasses.track}`}
              fill="none"
              strokeWidth="3"
              d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <path
              className={`stroke-current ${colorClasses.circle}`}
              fill="none"
              strokeWidth="3"
              strokeLinecap="round"
              strokeDasharray={`${percentage}, 100`}
              d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <text
              x="18"
              y="20.35"
              className="fill-current text-gray-800 text-[5px] font-semibold text-center"
              textAnchor="middle"
            >
              {percentage}%
            </text>
          </svg>
        </div>
      )}

      <div className="flex-grow">
        <h3 className="text-lg font-medium text-gray-700">{title}</h3>
        <p className="text-sm text-gray-500 mb-2">{subtitle}</p>
        <p
          className={`text-xl font-semibold ${
            isMonetary ? colorClasses.text : "text-gray-800"
          }`}
        >
          {isMonetary && <span>₹</span>} {value}
        </p>
      </div>
    </div>
  );
};

export default MetricCard;
